import { useEffect, useState } from "react";
import { toast } from "sonner";
import api from "@/lib/api";

const EMPTY = { shortcut: "", title: "", category: "general", body: "" };

/** Admin-only create / edit / archive. The server re-checks the role and workspace on every call. */
export function QuickRepliesManage({ onChanged }) {
  const [rows, setRows] = useState([]);
  const [meta, setMeta] = useState({ categories: [], placeholders: [] });
  const [form, setForm] = useState(EMPTY);
  const [editing, setEditing] = useState(null);
  const load = () => api.get("/wa-web/quick-replies", { params: { include_archived: true } }).then((r) => { setRows(r.data.items); setMeta(r.data); });
  useEffect(() => { load(); }, []);
  const err = (e) => toast.error(e.response?.data?.detail || "Save failed");
  const save = async () => {
    try {
      if (editing) await api.put(`/wa-web/quick-replies/${encodeURIComponent(editing)}`, form);
      else await api.post("/wa-web/quick-replies", form);
      toast.success("Saved"); setForm(EMPTY); setEditing(null); load(); onChanged?.();
    } catch (e) { err(e); }
  };
  const archive = async (r) => { try { await api.post(`/wa-web/quick-replies/${encodeURIComponent(r.id)}/archive`, { archived: !r.archived }); load(); onChanged?.(); } catch (e) { err(e); } };
  const set = (k) => (e) => setForm({ ...form, [k]: e.target.value });
  return (
    <div className="space-y-3" data-testid="qr-manage">
      <div className="grid gap-2 sm:grid-cols-3">
        <input value={form.shortcut} onChange={set("shortcut")} disabled={!!editing} placeholder="/greeting" className="rounded border px-2 py-1 font-mono text-sm" data-testid="qr-form-shortcut" />
        <input value={form.title} onChange={set("title")} placeholder="Title" className="rounded border px-2 py-1 text-sm" data-testid="qr-form-title" />
        <select value={form.category} onChange={set("category")} className="rounded border px-2 py-1 text-sm" data-testid="qr-form-category">{meta.categories.map((c) => <option key={c} value={c}>{c}</option>)}</select>
      </div>
      <textarea value={form.body} onChange={set("body")} rows={4} placeholder="Message text" className="w-full rounded border p-2 text-sm" data-testid="qr-form-body" />
      <div className="text-[11px] text-slate-500">Allowed placeholders: {meta.placeholders.map((p) => `{${p}}`).join(" ")}. Type prices, stock and dates yourself; they are never filled in automatically.</div>
      <div className="flex gap-2">
        <button type="button" onClick={save} className="rounded bg-emerald-700 px-3 py-1.5 text-sm text-white" data-testid="qr-form-save">{editing ? "Save changes" : "Add reply"}</button>
        {editing && <button type="button" onClick={() => { setEditing(null); setForm(EMPTY); }} className="rounded border px-3 py-1.5 text-sm" data-testid="qr-form-cancel">Cancel</button>}
      </div>
      <ul className="divide-y rounded border text-sm" data-testid="qr-manage-list">
        {rows.map((r) => (
          <li key={r.id} className={`flex items-center gap-2 px-2 py-1.5 ${r.archived ? "opacity-50" : ""}`} data-testid={`qr-row-${r.shortcut.slice(1)}`}>
            <span className="font-mono">{r.shortcut}</span><span className="flex-1 truncate">{r.title}</span><span className="text-[11px] text-slate-500">{r.category}</span>
            <button type="button" className="text-xs text-sky-700" onClick={() => { setEditing(r.id); setForm({ shortcut: r.shortcut, title: r.title, category: r.category, body: r.body }); }} data-testid={`qr-edit-${r.shortcut.slice(1)}`}>Edit</button>
            <button type="button" className="text-xs text-amber-700" onClick={() => archive(r)} data-testid={`qr-archive-${r.shortcut.slice(1)}`}>{r.archived ? "Restore" : "Archive"}</button>
          </li>))}
      </ul>
    </div>
  );
}
